export default __webpack_public_path__ + "assets/webgl/complete-4.85cb0036.jpg";